import React, { Fragment } from 'react';
import { ForgeIcon, ForgeListItem, ForgeTooltip } from '@tylertech/forge-react';

interface IAuthoringWorkflowTabProps {
  id: string;
  title: string;
  icon: string;
  selected?: boolean;
  onTabNavigation: (tabId: string) => void;
}

export const AuthoringWorkflowTab = ({
  id,
  title,
  icon,
  selected,
  onTabNavigation,
}: IAuthoringWorkflowTabProps) => {
  return (
    <Fragment key={id}>
      <ForgeListItem
        id={id}
        indented={false}
        aria-label={title}
        aria-controls={`${id}-panel`}
        className={`panel-btn ${id}-panel-btn`}
        selected={selected}
        onClick={() => onTabNavigation(id)}
      >
        <ForgeIcon slot="start" name={icon} />
      </ForgeListItem>
      <ForgeTooltip anchor={id} delay={500} position={'right'}>
        {title}
      </ForgeTooltip>
    </Fragment>
  );
};
